import { VisuallyHidden } from "reakit";
import { Box } from "../../Box/Box";

import { MONTHS, COUNT_IN_ROW } from "../constants";
import { useCalendarContext } from "../context";
import { parseDate } from "../helpers";
import { Month } from "./Month/Month";

export function MonthsCalendar() {
  const { currentDate, calendarId } = useCalendarContext();
  const originalDate = new Date(currentDate);
  const monthInRow = COUNT_IN_ROW.months;

  let rows = [];
  let row = [];
  for (let month = 0; month < MONTHS.length; month++) {
    row.push(month);
    if ((month + 1) % monthInRow === 0) {
      rows.push(row);
      row = [];
    }
  }
  return (
    <Box
      as="table"
      role="grid"
      aria-labelledby={calendarId}
      styles={{
        borderCollapse: "collapse",
        tableLayout: "fixed",
      }}
      width={1}
    >
      <VisuallyHidden as="caption">Выберите месяц</VisuallyHidden>
      <Box as="tbody">
        {rows.map((singleRow) => (
          <Box as="tr" key={singleRow[0]}>
            {singleRow.map((month) => (
              <Box key={month} as="td" border={1} borderColor="calendarBtnBorderColor" p={0}>
                <Month data-date={parseDate(new Date(originalDate.getFullYear(), month, 1))} />
              </Box>
            ))}
          </Box>
        ))}
      </Box>
    </Box>
  );
}
